<template>
    <div class="AddressQuestion">
        <header class="QuestionHeader">
            <h3>{{ question.metadata.title }}</h3>
            <p>{{ question.metadata.description }}</p>
        </header>
        <AddressInput :value="value" @input="onChange" />
    </div>
</template>

<script lang="ts">
    import { Component } from 'vue-property-decorator';

    import AddressInput from '@/components/forms/AddressInput.vue';
    import Dropdown from '@/components/forms/Dropdown.vue';
    import FieldComponent from '@/fields/FieldComponent';
    import AddressValue from '@/fields/interfaces/Address';

    @Component({
        emits: [ 'change' ],
        components: { AddressInput, Dropdown },
    })
    export default class Address extends FieldComponent<AddressValue> {
        private onChange(value: AddressValue) {
            this.$emit('change', value);
        }
    }
</script>
